import React from "react";
import { Route, Redirect } from 'react-router-dom';

function ProfesionalRoute({ component: Component, ...rest }) {

    return <Route {...rest} render={(props) => {

        let userdata = null;
        try {
            const raw = localStorage.getItem('userdata');
            if (raw) userdata = JSON.parse(raw);
        } catch (e) {
            userdata = null;
        }

        if (userdata && userdata.firma && userdata.registro) {
            return <Component {...props} />;
        }

        // Antes redirigía en silencio al dashboard; explicamos el motivo en Home con un modal
        return (
            <Redirect
                to={{
                    pathname: '/home',
                    state: { profesionalRequisitos: true }
                }}
            />
        );
    }} />;
}

export default ProfesionalRoute;